<template>
  <div class="member">
    <div class="banner-top">
      <div class="banner-box">博览财经资讯服务</div>
      <div class="banner-desc">开通会员，畅阅全站专属资讯内容</div>
    </div>
    <div class="member-box">
      <!-- 付费说明 -->
      <div class="pay-guide">
        <div class="pay-guide-title">付费说明</div>
        <div class="pay-guide-list">
          <div class="pay-guide-item">
            <div class="step-num">1</div>
            <div class="step-content">
              <div class="step-label">选择套餐</div>
              <div class="step-desc">浏览下方套餐，点击"立即购买"进入订单确认页</div>
            </div>
          </div>
          <div class="pay-guide-item">
            <div class="step-num">2</div>
            <div class="step-content">
              <div class="step-label">填写信息</div>
              <div class="step-desc">未登录用户填写手机号，系统自动注册账户；已登录用户直接下单</div>
            </div>
          </div>
          <div class="pay-guide-item">
            <div class="step-num">3</div>
            <div class="step-content">
              <div class="step-label">选择支付方式</div>
              <div class="step-desc">在线支付（扫码支付，推荐）或银行转账（需人工核对到账）</div>
            </div>
          </div>
          <div class="pay-guide-item">
            <div class="step-num">4</div>
            <div class="step-content">
              <div class="step-label">完成支付</div>
              <div class="step-desc">在线支付扫码后点击"已完成支付"；转账支付按要求汇款后点击"已完成转账"</div>
            </div>
          </div>
          <div class="pay-guide-item">
            <div class="step-num">5</div>
            <div class="step-content">
              <div class="step-label">人工审核</div>
              <div class="step-desc">客服在1个工作日内审核到账情况，审核通过后自动开通会员权限</div>
            </div>
          </div>
          <div class="pay-guide-item">
            <div class="step-num">6</div>
            <div class="step-content">
              <div class="step-label">开通成功</div>
              <div class="step-desc">收到站内消息通知，可在个人中心查看会员有效期、下载电子合同</div>
            </div>
          </div>
        </div>
        <div class="pay-guide-tip">
          <i class="el-icon-info"></i>
          <span>会员权益：全站资讯畅阅（大势/复盘/市场/机会/个股/特色/投研库等栏目）<br/>
          服务期限：以套餐时长为准，自开通之日起计算<br/>
          电子合同：审核通过后自动生成，可在"个人中心-我的订单"下载</span>
        </div>
      </div>

      <!-- 风险提示 醒目固定展示 -->
      <div class="risk-notice">
        <div class="risk-notice-title">【风险提示】</div>
        <div class="risk-notice-content">
          本产品为金融市场资讯数据整合查阅服务，不属于证券投资咨询服务，不构成任何投资建议、买卖推荐或收益承诺。市场有风险，投资需谨慎，所有投资决策及相应损失由用户自行承担。
        </div>
        <div class="risk-notice-content">
          本产品为数字化在线服务，一经开通交付，非乙方违约原因不支持退款，请确认需求后下单。
        </div>
      </div>

      <!-- 套餐列表 -->
      <div class="package-list">
        <div class="package-card" v-for="item in packages" :key="item.id">
          <div class="package-name">{{ item.name }}</div>
          <div class="package-duration">服务期限：{{ item.duration }}个月</div>
          <div class="package-price-box">
            <div class="package-price">￥{{ item.price }}<span class="package-price-unit">（含税）</span></div>
            <div class="package-original-price">原价 ￥{{ item.original_price }}</div>
          </div>
          <div class="package-desc">{{ item.desc }}</div>
          <div class="package-buy">
            <el-button type="primary" class="buy-btn" @click="toBuy(item)">立即购买</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Packages } from "@/api/order";
export default {
  name: "Member",
  data() {
    return {
      token: window.localStorage.getItem('token'),
      username: window.localStorage.getItem('username'),
      packages: [
        {id: 1, name: '月度会员', price: 2980.00, original_price: 3288.00, duration: '1个月', desc: '全站资讯畅阅1个月'},
        {id: 2, name: '半年会员', price: 14900.00, original_price: 19888.00, duration: '6个月', desc: '全站资讯畅阅6个月'},
        {id: 3, name: '年度会员', price: 29800.00, original_price: 38888.00, duration: '12个月', desc: '全站资讯畅阅12个月，最受欢迎'},
      ],
    }
  },
  created() {
    this.$emit('header', true);
    this.$emit('footer', true);
    this.getPackageList();
  },
  methods: {
    getPackageList() {
      Packages({}).then((response) => {
        if (response && (response.code === 2000 || response.code === 200) && response.data && response.data.length) {
          this.packages = response.data;
        }
      }).catch((err) => {
        // 接口未就绪，使用内置套餐数据
        console.log('套餐接口请求失败，使用默认数据', err);
      });
    },
    toBuy(item) {
      // 允许未登录用户直接进入订单页，由订单页处理自动注册
      this.$router.push({path: '/Order', query: {package_id: item.id}});
    },
  }
}
</script>

<style scoped>
.banner-top {
  width: 100%;
  height: 100px;
  margin-top: 50px;
  background: url("../assets/images/banner_top.png") no-repeat center / cover;
  text-align: center;
  color: #fff;
}
.banner-box {
  font-size: 30px;
  font-weight: 600;
  line-height: 60px;
  padding-top: 10px;
}
.banner-desc {
  font-size: 16px;
}
.member-box {
  width: 1200px;
  margin: 20px auto 40px;
}
.pay-guide {
  background: #fff;
  border-radius: 6px;
  padding: 24px 28px;
  margin-bottom: 24px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}
.pay-guide-title {
  font-size: 20px;
  font-weight: 600;
  color: #001646;
  margin-bottom: 18px;
  padding-bottom: 12px;
  border-bottom: 2px solid #001646;
}
.pay-guide-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px 40px;
  margin-bottom: 18px;
}
.pay-guide-item {
  display: flex;
  align-items: flex-start;
  width: calc(33.333% - 27px);
}
.step-num {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #001646;
  color: #ffe400;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 600;
  margin-right: 12px;
}
.step-content {
  flex: 1;
}
.step-label {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 4px;
}
.step-desc {
  font-size: 13px;
  color: #898989;
  line-height: 20px;
}
.pay-guide-tip {
  background: #f0f5ff;
  border-left: 4px solid #001646;
  padding: 12px 16px;
  font-size: 13px;
  color: #303133;
  line-height: 24px;
  border-radius: 0 4px 4px 0;
}
.pay-guide-tip i {
  color: #001646;
  margin-right: 6px;
}
.risk-notice {
  background: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 4px;
  padding: 16px 20px;
  margin-bottom: 24px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}
.risk-notice-title {
  color: #d4380d;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
}
.risk-notice-content {
  color: #5c3a00;
  font-size: 13px;
  line-height: 22px;
  margin-bottom: 4px;
}
.package-list {
  display: flex;
  /* 水平居中 */
  justify-content: center;
}
.package-card {
  width: 380px;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 30px 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.package-name {
  font-size: 22px;
  font-weight: 600;
  color: #001646;
  margin-bottom: 8px;
}
.package-duration {
  font-size: 14px;
  color: #898989;
  margin-bottom: 20px;
}
.package-price-box {
  text-align: center;
  margin-bottom: 16px;
}
.package-price {
  font-size: 32px;
  font-weight: 700;
  color: #d4380d;
}
.package-price-unit {
  font-size: 14px;
  color: #d4380d;
  font-weight: 400;
}
.package-original-price {
  font-size: 14px;
  color: #b0b0b0;
  text-decoration: line-through;
  margin-top: 6px;
}
.package-desc {
  font-size: 14px;
  color: #595959;
  line-height: 24px;
  text-align: center;
  min-height: 48px;
  margin-bottom: 20px;
}
.package-buy {
  width: 100%;
}
>>> .buy-btn {
  width: 100%;
  background-color: #001646 !important;
  border-color: #001646 !important;
}
>>> .buy-btn:hover,
>>> .buy-btn:focus {
  background-color: #0a2a6e !important;
  border-color: #0a2a6e !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Member.vue